/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const availabilityRangeBulkCreateItemSchema = z.object({
  endDate: z.iso.date(),
  name: z.string().min(0).max(255),
  startDate: z.iso.date(),
});
